import { useRouter } from 'next/router';
import QRCode from 'qrcode.react';
import React from 'react';
import styled from 'styled-components';

import BestQuestions from '@/components/templates/communication/Qna/BestQuestions';
import { getPageName, mobileLogger } from '@/utils/logger';

const Link = 'https://abr.ge/oqmbrwn';

const DefaultGlobalSideBar = () => {
  const router = useRouter();
  const onClickBanner = async () => {
    router.push(Link);
    mobileLogger({
      logger: {
        eventName: 'right_side_banner_app_download_click',
        pageName: getPageName(router),
        payload: {
          platform: 'web',
        },
      },
    });
  };

  return (
    <Wrapper>
      <div
        role='button'
        onClick={onClickBanner}
        className='relative mx-[12px] flex min-h-[360px] w-[calc(100%-12px)] cursor-pointer flex-col items-start rounded-[8px] bg-gradient-to-r from-[#FF8701] to-[#FF7501] p-[24px] '
      >
        <div className='typography-ui-15m text-white'>지금 당장 진료가 필요하다면?</div>
        <div className='typography-ui-24b mt-[4px] text-white'>
          닥터나우는
          <br />
          늦은밤, 주말에도
          <br />
          진료 가능해요!
        </div>
        <img
          src={'https://file.doctornow.co.kr/landing/app_install_image.png'}
          alt='앱 설치 유도 이미지'
          className='-translate-x-1/2 absolute bottom-0 left-[50%] w-full object-contain'
        />
      </div>

      <DownloadQrBox>
        <DownloadGuide>{'QR찍고\n앱 다운로드하기'}</DownloadGuide>
        <QRCode value={'https://abr.ge/ftzhdsc'} size={48} />
      </DownloadQrBox>
      <BestQuestions marginTop={32} />
    </Wrapper>
  );
};

export default DefaultGlobalSideBar;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 296px;
  min-width: 296px;
  padding: 24px 12px;
  position: sticky;
  top: 0;
  align-self: flex-start;
`;

const DownloadQrBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 12px;
  margin-top: 16px;
  padding-right: 12px;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.color.gray50};
  border-bottom-style: solid;
  padding-bottom: 36px;
`;

const DownloadGuide = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI17SB};
    color: ${theme.color.gray700};
    white-space: pre-wrap
  `}
`;
